// Dev-only logger. Stripped from console output in production builds.
export const logError = (...args) => {
  if (process.env.NODE_ENV !== 'production') {
    console.error(...args);
  }
};
